<template>
    <div>
        <data-table v-if="showView === 'listpage'" ref="dataTable" class="dataTable" :module-info="moduleInfo" :tb-columns="tbColumns" :toolbar-btns="listpageBtns" :on-list-data-before-load="onListDataBeforeLoad" :show-toolbar="0" :on-list-data-loaded="onListDataLoaded" :on-cell-click="cellclick" :on-selected-rows-change="selectedRowsChange">
            <slot slot="top">
                <div style="">
                    <div class="dragpanel-container">
                        <form class="el-form">
                            <div class="el-table el-table--fit el-table--border" style="100%">
                                <div class="el-table__body-wrapper">
                                    <table cellspacing="0" cellpadding="0" border="0" class="el-table__body el-table__body-no">
                                        <tbody>
                                            <tr>
                                                <td class="el-table__cell tdlbl tdw17" colspan="1">项目名称</td>
                                                <td class="el-table__cell tdcont tdw33" colspan="1">
                                                    <el-input v-model="searchMap.flSubject" placeholder="请输入项目名称" />
                                                </td>

                                                <td class="el-table__cell tdlbl tdw17" colspan="1">合同日期(开始)</td>
                                                <td class="el-table__cell tdcont tdw33" colspan="1">
                                                    <el-date-picker v-model="searchMap.contractDate_START" style="width: 100%" :format="'yyyy-MM-dd HH:mm'" value-format="yyyy-MM-dd HH:mm" type="datetime" :placeholder="'合同签订日期(开始)'" />
                                                </td>
                                                <td class="el-table__cell tdlbl tdw17" colspan="1">合同日期(结束)</td>
                                                <td class="el-table__cell tdcont tdw33" colspan="1">
                                                    <el-date-picker v-model="searchMap.contractDate_END" style="width: 100%" :format="'yyyy-MM-dd HH:mm'" value-format="yyyy-MM-dd HH:mm" type="datetime" :placeholder="'合同签订日期(结束)'" />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td class="el-table__cell tdlbl tdw17" colspan="1">业务类型</td>
                                                <td class="el-table__cell tdcont tdw33" colspan="1">
                                                    <el-select v-model="searchMap.xmBusiType" style="width: 100%" placeholder="请选择业务类型">
                                                        <el-option v-for="item in xmBusiTypeOption" :key="item.value" :label="item.label" :value="item.value"></el-option>
                                                    </el-select>
                                                </td>
                                                <td class="el-table__cell tdlbl tdw17" colspan="1">工程造价金额(开始)</td>
                                                <td class="el-table__cell tdcont tdw33" colspan="1">
                                                    <el-input v-model="urlsearchMap.xmAmountStart" type="number" placeholder="请输入工程造价金额(s开始)" />
                                                </td>
                                                <td class="el-table__cell tdlbl tdw17" colspan="1">工程造价金额(结束)</td>
                                                <td class="el-table__cell tdcont tdw33" colspan="1">
                                                    <el-input v-model="urlsearchMap.xmAmountEnd" type="number" placeholder="请输入工程造价金额(结束)" />
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </form>
                        <div class="panel-footer" style="padding: 10px; text-align: center">
                            <button type="button" class="el-button el-button--default el-button--medium color" @click="submitSearch">
                                <i class="el-icon-search" />
                                <span>开始搜索</span>
                            </button>
                            <button type="button" class="el-button el-button--default el-button--medium" @click="resetSearch">
                                <i class="el-icon-close" />
                                <span>清除搜索</span>
                            </button>
                        </div>
                    </div>
                </div>
            </slot>
        </data-table>
    </div>
</template>

<script>
export default {
    components: {},
    props: {
        // 通用属性
        vo: {
            type: Object,
            default: function () {
                return {}
            }
        },
        canEdit: { type: Number, default: 1 }
    },
    data() {
        return {
            moduleInfo: {
                formTemplate: 'dcontent/busiformurl?vwtype=W&url=/zjgl/zjxmJggd/form.html',
                addNewUrl: 'zjgl/zjxmJggd/addNew', insertUrl: 'zjgl/zjxmJggd/insert',
                getByIdUrl: 'zjgl/zjxmJggd/getById', updateUrl: 'zjgl/zjxmJggd/update',
                delUrl: 'zjgl/zjxmJggd/delete', listDataUrl: 'zjgl/zjxmArch/listdata', winWidth: 1000, winHeight: 600, moduleCode: 'zjxmJggd', openViewType: '0', listAdvSearchAllFields: 0, listAdvSearchExpandPanel: 0 },
            tbColumns: [
                { field: 'state', checkbox: true, width: '45px', align: 'center', sortable: false, fixed: 'false' },
                { align: 'center', field: 'index', title: '序号', width: '45px', sortable: false, fixed: 'false', listAdvSearchElement: '', searchable: false, propType: '' },
                { align: 'center', field: 'projectCode', title: '公司统一编号', width: '150px', sortable: true, listAdvSearchElement: 'input', searchable: true, listAdvSearchIndex: 0, propType: 'String' },
                { align: 'center', field: 'contractDate', title: '合同日期', width: '150px', sortable: true, fixed: 'false', listTdEdit: 0, listAdvSearchElement: 'date', searchable: true, listAdvSearchIndex: 1, propType: 'java.util.Date', propFormatter: 'format：yyyy年MM月dd日' },
                { align: 'left', field: 'flSubject', title: '项目名称', width: '', sortable: true, fixed: 'false', listTdEdit: 0, listAdvSearchElement: 'input', searchable: true, listAdvSearchIndex: 2, propType: 'String' },
                { align: 'center', field: 'xmBusiType', title: '业务类型', width: '150px', sortable: true, listAdvSearchElement: 'input', searchable: true, listAdvSearchIndex: 3, propType: 'Short', elementFormatter: '1：工程造价签定报告\n2：评估报告\n3：工程量验收报告\n4：概算\n5：预算\n6：预算评审报告\n7：结算\n8：结算审核报告\n9：工程量清单\n10：预算控制价审核\n11：全过程\n12：招标控制价' },
                { align: 'center', field: 'xmAmount', title: '工程造价金额（元）', width: '180px', sortable: true, fixed: 'false', listTdEdit: 0, listAdvSearchElement: 'input', searchable: true, listAdvSearchIndex: 4, propType: 'java.math.BigDecimal' },
                { align: 'center', field: 'xmFzr', title: '项目负责人', width: '150px', sortable: true, listAdvSearchElement: 'input', searchable: true, listAdvSearchIndex: 5, propType: 'String' },
                { align: 'center', field: 'compilePerson', title: '编制审核人', width: '150px', sortable: true, fixed: 'false', listTdEdit: 0, listAdvSearchElement: 'input', searchable: true, listAdvSearchIndex: 6, propType: 'String' },
                // { align: 'center', field: 'wfNodeNames', title: '处理环节', width: '120px', sortable: true, listAdvSearchElement: 'input', searchable: true, listAdvSearchIndex: 7, propType: 'String' },
                { enabled: false, align: 'left', field: 'flSubject', title: '申请事由', width: '100px', sortable: false, listAdvSearchElement: '', searchable: false, propType: 'String' },
                { enabled: false, align: 'left', field: 'flCreateDept', title: '申请部门', width: '100px', sortable: false, listAdvSearchElement: '', searchable: false, propType: 'String' },
                { enabled: false, align: 'center', field: 'flCreateDate', title: '申请日期', width: '110px', sortable: false, listAdvSearchElement: '', searchable: false, propType: 'java.util.Date', elementFormatter: 'format：yyyy年MM月dd日\r\n' },
                { enabled: false, align: 'center', field: 'flCreator', title: '申请人', width: '85px', sortable: false, listAdvSearchElement: '', searchable: false, propType: 'String' },
                { enabled: false, align: 'center', field: 'status', title: '状态', width: '75px', sortable: false, listAdvSearchElement: '', searchable: false, propType: 'Short', elementFormatter: '0：草稿\r\n1：处理中\r\n2：结束\r\n8：已归档\r\n9：已注销\r\n' },
                { enabled: false, align: 'center', field: 'archiveDate', title: '归档日期', width: '150px', sortable: false, listAdvSearchElement: '', searchable: false, propType: 'java.util.Date', elementFormatter: 'format：yyyy年MM月dd日\r\n' }
            ],
            listpageBtns: [],
            loginUser: this.$store.getters.loginUser,
            listStyle: {},
            showView: 'listpage',
            xmBusiTypeOption: [
                {
                    label: '工程造价签定报告',
                    value: 1
                },
                {
                    label: '评估报告',
                    value: 2
                },
                {
                    label: '工程量验收报告',
                    value: 3
                },
                {
                    label: '概算',
                    value: 4
                },
                {
                    label: '预算',
                    value: 5
                },
                {
                    label: '预算评审报告',
                    value: 6
                },
                {
                    label: '结算',
                    value: 7
                },
                {
                    label: '结算审核报告',
                    value: 8
                },
                {
                    label: '工程量清单',
                    value: 9
                },
                {
                    label: '预算控制价审核',
                    value: 10
                },
                {
                    label: '全过程',
                    value: 11
                },
                {
                    label: '招标控制价',
                    value: 12
                }
            ],
            searchMap: {
                flSubject: '',
                contractDate_START: '',
                contractDate_END: '',
                xmBusiType: ''
            },
            urlsearchMap: {
                xmAmountStart: '',
                xmAmountEnd: ''
            }
        }
    },
    computed: {},
    watch: {},
    created() {},
    beforeDestroy() {},
    mounted() {},
    methods: {
        resetSearch() {
            this.searchMap = {
                projectName: '',
                contractDate_START: '',
                contractDate_END: '',
                xmBusiType: '',
                zbWay: ''
            }
            this.urlsearchMap = {
                xmAmountStart: '',
                xmAmountEnd: ''
            }

            this.$nextTick(() => {
                this.$bus.emit('refreshListData')
            })
        },
        submitSearch() {
            console.log(this.$refs.dataTable, '  this.$refs.dataTable')
            this.$refs.dataTable.searchMap = this.searchMap
            this.$refs.dataTable.searchAndOr = 'AND'
            if (this.urlsearchMap.xmAmountStart || this.urlsearchMap.xmAmountEnd) {
                this.moduleInfo.listDataUrl = 'zjgl/zjxmArch/listdata?' + 'xmAmountStart=' + this.urlsearchMap.xmAmountStart + '&xmAmountEnd =' + this.urlsearchMap.xmAmountEnd
            } else {
                this.moduleInfo.listDataUrl = 'zjgl/zjxmArch/listdata'
            }
            this.$nextTick(() => {
                this.$bus.emit('refreshListData')
            })
        },
        /**
         * 处理选中行变化的事件
         *
         * @param row 当前选中的行对象
         */
        selectedRowsChange(row) {
            this.$bus.emit('selectRow', row) // 传给借阅申请的子表
        },
        cellclick(row) {
            console.log(row, 'row')
            this.$http({
                url: 'zjgl/zjxmArch/listdata',
                method: 'post',
                params: {
                    urlsearch: 'projectCode:' + row.projectCode
                },
                contentType: 'application/x-www-form-urlencoded'
            }).then((res) => {
                const linkrow = res.body.pageInfo.list[0]
                window.open('#/zjtzView?wfEngineUrl=zjgl/zjxmArch&busiDataId=' + linkrow.id + '&logoTitle=' + encodeURIComponent('造价管理/' + linkrow.flSubject) + '&type=' + 'attachment' + '&canEdit=' + (this.vo.status === 2 ? '1' : '0'))
            })
        },
        /**
         * 加载数据完成，pageInfo为包含查询结果的分页信息对象，不需要返回值
         */
        onListDataLoaded: function ($scope, pageInfo) {
            console.log('fgsgl listdata loaded')
        },
        /**
         * 加载数据准备，qparams为查询参数对象，不需要返回值
         */
        onListDataBeforeLoad: function ($scope, qparams) {
            this.loginUser = $scope.loginUser
            qparams.listpageId = 'c859927c59654a54a54fa7f5d45fcfb6'
            qparams.urlsearch = 'borrowStatus:1'
            if (!qparams.orderBy) {
                qparams.orderBy = ''
            }
            console.log('fgsgl listdata before load..')
        }
    }
}
</script>

<style scoped lang="scss"></style>
